import { Injectable } from '@angular/core';
import { ApiWorkOrderBlockingMotivesAdapterService } from '@fullyops/data/work-order-blocking-motives/api-adapter.service';
import { WorkOrderBlockingMotive } from '@fullyops/data/work-order-blocking-motives/blocking-motives';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteAllEntities,
  deleteEntities,
  selectAllEntities,
  setEntities,
  upsertEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { v4 as getUuid } from 'uuid';

@Injectable({ providedIn: 'root' })
export class WorkOrderBlockingMotivesService {
  constructor(private api: ApiWorkOrderBlockingMotivesAdapterService) {}

  private store = createStore(
    { name: 'blocking-motives' },
    withEntities<WorkOrderBlockingMotive>({ idKey: 'id' }),
  );

  motives$ = this.store.pipe(selectAllEntities());

  refresh(): void {
    this.api.getAll().subscribe((res) => this.store.update(setEntities(res)));
  }

  clear(): void {
    this.store.update(deleteAllEntities());
  }

  create(name: string): void {
    const provisionalId = getUuid();
    this.store.update(addEntities({ id: provisionalId, name }));
    this.api.create(name).subscribe({
      next: (res) => {
        this.store.update(
          deleteEntities(provisionalId),
          upsertEntities({ id: res.id, name }),
        );
      },
      error: () => {
        this.store.update(deleteEntities(provisionalId));
      },
    });
  }

  delete(id: string): void {
    const orig = this.store.getValue().entities[id];
    this.store.update(deleteEntities(id));
    this.api.delete(id).subscribe({
      error: () => {
        this.store.update(addEntities(orig));
      },
    });
  }
}
